/**
 * Search overlay - OLD theme migration
 * Fullscreen modal, products + Journal (articles) when search_mode allows.
 * Products left, Journal right (PageLayout). View All for each opens full results.
 */
(function() {
  'use strict';

  function initSearchOverlay() {
    var searchEl = document.getElementById('Search');
    var pageOverlayEl = document.querySelector('.PageOverlay');
    if (!searchEl || !pageOverlayEl) return;

    var inputEl = searchEl.querySelector('[name="q"]');
    var resultsEl = searchEl.querySelector('.Search__Results');
    if (!inputEl || !resultsEl) return;

    var lastInputValue = '';
    var debounceTimer = null;
    var activeModal = null;

    function debounce(fn, delay) {
      return function() {
        var ctx = this;
        var args = arguments;
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function() { fn.apply(ctx, args); }, delay);
      };
    }

    function openSearch(e) {
      var target = e.target.closest('[data-action="open-modal"]');
      if (!target || target.getAttribute('aria-controls') !== 'Search') return;

      e.preventDefault();
      e.stopPropagation();
      if (activeModal) return;

      activeModal = searchEl;
      searchEl.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('no-scroll');
      inputEl.value = '';
      lastInputValue = '';
      var searchMode = (window.theme && window.theme.searchMode) || 'product';
      resultsEl.innerHTML = (searchMode === 'product') ? '' : '<div class="PageLayout PageLayout--breakLap"><div class="PageLayout__Section"></div><div class="PageLayout__Section PageLayout__Section--secondary"></div></div>';
      if (document.documentElement.dispatchEvent) {
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end'));
      }
      requestAnimationFrame(function() {
        inputEl.focus();
      });
    }

    function closeSearch(e) {
      var target = e && e.target ? e.target.closest('[data-action="close-modal"]') : null;
      if (target && activeModal !== searchEl) return;
      if (!target && e && e.type === 'click') {
        if (e.target === pageOverlayEl || pageOverlayEl.contains(e.target)) {
          /* overlay click */
        } else {
          return;
        }
      }
      if (!activeModal) return;

      activeModal = null;
      searchEl.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('no-scroll');
    }

    function onKeydown(e) {
      if (e.keyCode === 27) {
        closeSearch({});
      }
      if (e.keyCode === 13 && (window.theme && window.theme.searchMode !== 'product')) {
        e.preventDefault();
      }
    }

    function resetSearch() {
      var searchMode = (window.theme && window.theme.searchMode) || 'product';
      if (searchMode === 'product') {
        resultsEl.innerHTML = '';
      } else {
        resultsEl.innerHTML = '<div class="PageLayout PageLayout--breakLap"><div class="PageLayout__Section"></div><div class="PageLayout__Section PageLayout__Section--secondary"></div></div>';
      }
      if (document.documentElement.dispatchEvent) {
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end'));
      }
    }

    function onInput(e) {
      if (e.keyCode === 13) return;

      lastInputValue = inputEl.value;

      if (lastInputValue === '') {
        resetSearch();
        return;
      }

      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start'));

      var searchMode = (window.theme && window.theme.searchMode) || 'product';
      var queryOpts = { method: 'GET', credentials: 'same-origin' };
      var encodedQ = encodeURIComponent(lastInputValue) + '*';

      if (searchMode === 'product') {
        fetch('/search?view=ajax&q=' + encodedQ + '&type=product', queryOpts)
          .then(function(res) { return res.text(); })
          .then(function(html) {
            if (inputEl.value !== lastInputValue) return;
            resultsEl.innerHTML = html;
            document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end'));
          })
          .catch(function() {
            if (inputEl.value !== lastInputValue) return;
            resetSearch();
          });
      } else {
        var typeSecondary = searchMode.replace(/^product,?/, '');
        var urlProduct = '/search?view=ajax&q=' + encodedQ + '&type=product';
        var urlSecondary = '/search?view=ajax&q=' + encodedQ + '&type=' + encodeURIComponent(typeSecondary);
        Promise.all([
          fetch(urlProduct, queryOpts).then(function(r) { return r.text(); }),
          fetch(urlSecondary, queryOpts).then(function(r) { return r.text(); })
        ]).then(function(contents) {
          if (inputEl.value !== lastInputValue) return;
          resultsEl.innerHTML = '<div class="PageLayout PageLayout--breakLap"><div class="PageLayout__Section">' + contents[0] + '</div><div class="PageLayout__Section PageLayout__Section--secondary">' + contents[1] + '</div></div>';
          document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end'));
        }).catch(function() {
          if (inputEl.value !== lastInputValue) return;
          resetSearch();
        });
      }
    }

    inputEl.addEventListener('keydown', function(e) {
      if (e.keyCode === 13 && (window.theme && window.theme.searchMode === 'product')) {
        inputEl.closest('form').submit();
      }
      if (e.keyCode === 13 && (window.theme && window.theme.searchMode !== 'product')) {
        e.preventDefault();
      }
    });
    inputEl.addEventListener('input', debounce(onInput, 250));

    document.body.addEventListener('click', function(e) {
      var openBtn = e.target.closest('[data-action="open-modal"]');
      if (openBtn && openBtn.getAttribute('aria-controls') === 'Search') {
        openSearch(e);
        return;
      }
      var closeBtn = e.target.closest('[data-action="close-modal"]');
      if (closeBtn) {
        e.preventDefault();
        closeSearch(e);
        return;
      }
      if (e.target === pageOverlayEl && activeModal === searchEl) {
        closeSearch(e);
      }
    });

    document.addEventListener('keydown', function(e) {
      if (activeModal === searchEl && e.keyCode === 27) {
        closeSearch({});
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearchOverlay);
  } else {
    initSearchOverlay();
  }
})();
